import { inject, Injectable } from "@angular/core";
import { environment } from "../../../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { Adresse } from "../../models/adresse.model";
import { safeFirstValueFrom } from "../../../../shared/utils/safe-first-value-from";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class AdresseApiService {
  private http = inject(HttpClient);

  constructor() {}

  loadOne(id: string): Observable<Adresse> {
    return this.httpClient.get<Adresse>(
      `${environment.api()}/adresse/id/${id}`,
    );
  }

  httpClient = inject(HttpClient);

  create(entity: Adresse): Observable<Adresse> {
    return this.http.post<Adresse>(`${environment.api()}/adresse`, entity);
  }

  remove(id: string): Observable<string> {
    return this.http.delete<string>(`${environment.api()}/adresse/${id}`);
  }

  update(entity: Adresse): Observable<Adresse> {
    return this.http.post<Adresse>(`${environment.api()}/adresse`, entity);
  }

  loadAll(): Observable<Adresse[]> {
    return this.httpClient.get<Adresse[]>(`${environment.api()}/tiers`);
  }

  async loadAllForTiers(tiersId: string) {
    return await safeFirstValueFrom(
      this.http.get<Adresse[]>(`${environment.api()}/adresse/${tiersId}`),
    );
  }

  async loadAllForGroup() {
    return await safeFirstValueFrom(
      this.http.get<Adresse[]>(`${environment.api()}/adresse`),
    );
  }

  async setAdresseLivraisonDefaut(id: string) {
    return await safeFirstValueFrom(
      this.http.post<Adresse[]>(
        `${environment.api()}/adresse/set-livraison-default/${id}`,
        {},
      ),
    );
  }

  async removeAdresseLivraisonDefaut() {
    return await safeFirstValueFrom(
      this.http.post<Adresse[]>(
        `${environment.api()}/adresse/remove-livraison-default/`,
        {},
      ),
    );
  }

  reactivate(id: string): Observable<Adresse> {
    return this.http.post<Adresse>(
      `${environment.api()}/adresse/reactivate/${id}`,
      {},
    );
  }
}
